import React, { useEffect } from "react";
import { Routes, Route, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Header from "../Components/Header";
import Footer from "../Components/Footer";

import Home from "../Pages/Home";
import About from "../Pages/About";
import Blog from "../Pages/Blog";
import Contact from "../Pages/Contact";
import InvisibleCharacterGenerator from "../Pages/InvisibleCharacterGenerator";

const LangLayout = () => {
    const { lang } = useParams();
    const { i18n } = useTranslation();

    useEffect(() => {
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    return (
        <>
            <Header />
            <Routes>
                <Route path="" element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="blog" element={<Blog />} />
                <Route path="contact" element={<Contact />} />
                <Route path="invisible" element={<InvisibleCharacterGenerator />} />
            </Routes>
            <Footer />

        </>
    );
};

export default LangLayout;
